import Vue from 'vue'
import App from './App.vue'
import router from './router'
import $ from 'jquery' 
import Flickity from 'flickity'
import bootstrap from 'bootstrap'
import popper from 'popper.js'
import VueScrollTo from 'vue-scrollto'
import lax from 'lax.js'

require("expose-loader?$!jquery"); window.$ = $;

 //
 //
 //

Vue.config.productionTip = false
 
 //
 //
 //

Vue.use(VueScrollTo, {
	 container: "body",
	 duration: 750,
	 easing: "ease",
	 offset: 0,
	 force: true,
	 cancelable: true,
	 onStart: false,
	 onDone: false,
	 onCancel: false,
	 x: false,
	 y: true
})

Vue.directive('flickit', {
	inserted: function(el, binding) {
		let flick = new Flickity(el, {
			cellAlign: 'center',
			contain: true,
			wrapAround: true,
			autoPlay: false
		})
	}
})


//
//
//

$(window).scroll(function() {    
		var scroll = $(window).scrollTop();

	if (scroll > 36) {

		$('.site-header').addClass('site-header-scroll');
			$('.site-header-space').css(
			{
				'height' : '72px'
			});
	}

	if(scroll < 36){
		$('.site-header').removeClass('site-header-scroll');
		$('.site-header-space').css(
		{
			'height' : 0+'px'
		});
	}

});	

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')

